import type {UseBoundStore, StoreApi} from 'zustand';
import type {
  SetStateWithImmer,
  QuestionType
} from 'client/components/QuestionTypes/QuestionType.types';

export interface WordBankItem {
  id: string;
  value: string;
  placedInSlot: string | null; // null means it's in the skeleton/word bank
}
export interface DropSlot {
  id: string;
  label?: string;
}
export interface ItemBankState extends QuestionType.CoreState {
  // Layout-specific state
  wordBank: WordBankItem[];
  dropSlots: DropSlot[];
  placements: Record<string, string>; // {slotId: optionId}
  //
  activeItemId: string | null;
  isDragging: boolean;
}

export interface ItemBankActions extends QuestionType.CoreActions {
  // Interaction actions
  setActiveItem: (itemId: string | null) => void;
  placeItemInSlot: (itemId: string, slotId: string) => void;
  removeItemFromSlot: (slotId: string) => void;
  setIsDragging: (isDragging: boolean) => void;
  clearGuess: () => void;
  showSolution: () => void;

  // Computed helpers
  getItemInSlot: (slotId: string) => string | undefined;
  isSlotFilled: (slotId: string) => boolean;
  hasUserSelectedAnswer: () => boolean;
}

export const initialState: ItemBankState = {
  // question data
  question: null,
  questionId: null,
  // layout
  placements: {},
  wordBank: [],
  dropSlots: [],
  activeItemId: null,
  isDragging: false,
  // Draft guess state
  draftGuess: null,
  lastSaveTime: null,
  // guess info
  guess: null,
  isSubmitted: false,
  correctAnswer: null
};
export type FitbItemBankStore = ItemBankState & ItemBankActions;

export type StoreInstance = UseBoundStore<StoreApi<FitbItemBankStore>>;

export type SetState = SetStateWithImmer<FitbItemBankStore>; // replaces UseBoundStore<StoreApi<FitbItemBankStore>>['setState'];
export type GetState = UseBoundStore<StoreApi<FitbItemBankStore>>['getState'];
